import { setGA4Event } from "@iewcasia/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter, addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getProductById, GetProductByIdApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";

addToChainAfter(chain, ExecuteOnSuccessCallback, async props => {
    if (!props.result) {
        return;
    }

    const customWishListLines = [] as any[];

    // Use Promise.all to wait for all getProductById promises to resolve
    await Promise.all(
        props.parameter.productInfos.map(async productInfo => {
            const product = (await getProductById({
                id: productInfo.productId,
            } as GetProductByIdApiV2Parameter)) as any;

            // Add quantity to product object
            product.qtyOrdered = productInfo.qtyOrdered;

            customWishListLines.push(product);
        }),
    );

    // Check if customWishListLines is not empty before sending it to GA4
    if (customWishListLines.length > 0) {
        setGA4Event(customWishListLines, "add_to_wishlist");
    }
});
